// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__+eWLC","web_footer":"Footer_web_footer__5dRj4"};